import React from "react";
import Input from "../../../components/Input";
import MaskInput from "../../../components/MaskInput";
import { toPascalCase } from "../../../utils/AppUtils";
import { getPolicyType } from "../../../utils/AppUtils";
import { PRODUCT_TYPES } from "../../../utils/Constants";
import AmountDetails from "./AmountDetails";

const Form = ({ datos, mostrarModal, balancePoliza }) => {

  return (
    <div className="flex flex-1  flex-col md:flex-row lg:flex-row mx-2">
      <div className="mb-2 border-solid border-gray-300 rounded border shadow-sm w-full">
        <div className="bg-primary px-2 py-3 border-solid border-gray-200 border-b text-white">
          Detalles Facturación
        </div>

        <div className="p-3">
          <form className="w-full">
            <div className="flex flex-wrap -mx-3 mb-1">
              <div className="w-full md:w-1/2 px-3 mb-2 md:mb-0">
                <label
                  className="block  tracking-wide text-gray-700 text-xs font-light mb-1"
                  htmlFor="grid-first-name"
                >
                  Contratante
                </label>
                <Input
                  className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
                  id="grid-first-name"
                  type="text"
                  placeholder={toPascalCase(datos.data.contratante.nombre)}
                  disabled
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block tracking-wide text-gray-700 text-xs font-light mb-1"
                  htmlFor="grid-last-name"
                >
                  Póliza
                </label>
                <MaskInput
                  id="grid-zip"
                  value={datos.data.poliza}
                  mask="00-00-0000000000000"
                  maskChar={" "}
                  size={10}
                  disabled
                  className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-1">
              {
                getPolicyType(datos.data.poliza) === PRODUCT_TYPES.BUEN_VIAJE &&
                <div className="w-full md:w-1/2 px-3 mb-2 md:mb-0">
                  <label
                    className="block  tracking-wide text-gray-700 text-xs font-light mb-1"
                    htmlFor="grid-first-name"
                  >
                    Factura
                  </label>
                  <Input
                    className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
                    id="grid-first-name"
                    type="text"
                    // placeholder="858589"
                    placeholder={datos.data.factura}
                    disabled
                  />
                </div>}
              {/* <div className="w-full md:w-1/2 px-3">
                <div className="flex flex-wrap -mx-3 mb-1">
                  <div className="w-full md:w-1/2 px-3 mb-2 md:mb-0">
                    <label
                      className="block  tracking-wide text-gray-700 text-xs font-light mb-1"
                      htmlFor="grid-first-name"
                    >
                      Plan
                    </label>
                    <Input
                      className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
                      id="grid-first-name"
                      type="text"
                      placeholder={datos.data.plan.concat(' - ', datos.data.modalidad)}
                      disabled
                    />
                  </div>
                </div>
              </div> */}
              <div className="w-full md:w-1/2 px-3">
                <AmountDetails
                  balancePoliza={balancePoliza}
                  isBuenViaje={
                    getPolicyType(datos.data.poliza) ===
                    PRODUCT_TYPES.BUEN_VIAJE
                  }
                />
              </div>
              {/* <div className="w-full md:w-1/2 px-3">
                <div className="flex flex-wrap -mx-3 mb-1">
                  <div className="w-full md:w-1/2 px-3 mb-2 md:mb-0">
                    <label
                      className="block  tracking-wide text-gray-700 text-xs font-light mb-1"
                      htmlFor="grid-first-name"
                    >
                      Fecha Inicio Vigencia
                    </label>
                    <Input
                      className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
                      id="grid-first-name"
                      type="text"
                      placeholder={datos.data.vigencia.fechaDesde}
                      disabled
                    />
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <label
                      className="block  tracking-wide text-gray-700 text-xs font-light mb-1"
                      htmlFor="grid-last-name"
                    >
                      Fecha Fin Vigencia
                    </label>
                    <Input
                      className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
                      id="grid-first-name"
                      type="text"
                      placeholder={datos.data.vigencia.fechaHasta}
                      disabled
                    />
                  </div>
                </div>
              </div> */}
            </div>

            <div className="flex flex-wrap -mx-3 mb-2">
              {datos.data.contratante.tipoDocumento && <div className="w-full md:w-1/4 px-3 mb-2 md:mb-0">
                <label
                  className="block  tracking-wide text-grey-darker text-xs font-light mb-1"
                  htmlFor="grid-city"
                >
                  Tipo Documento
                </label>
                <Input
                  className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                  id="grid-city"
                  type="text"
                  placeholder={toPascalCase(datos.data.contratante.tipoDocumento)}
                  disabled
                />
              </div>}

              {datos.data.contratante.tipoDocumento && <div className="w-full md:w-1/4 px-3 mb-2 md:mb-0">
                <label
                  className="block  tracking-wide text-grey-darker text-xs font-light mb-1"
                  htmlFor="grid-city"
                >
                  Documento
                </label>
                {toPascalCase(datos.data.contratante.tipoDocumento) ===
                  "Cedula" ? (
                  <MaskInput
                    id="grid-zip"
                    value={datos.data.contratante.documento}
                    mask={"000-0000000-0"}
                    disabled
                    className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                  />
                ) : (
                  <Input
                    className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                    id="grid-city"
                    type="text"
                    placeholder={datos.data.contratante.documento}
                    disabled
                  />
                )}
              </div>}

              <div className="w-full md:w-1/4 px-3 mb-2 md:mb-0">
                <label
                  className="block  tracking-wide text-grey-darker text-xs font-light mb-1"
                  htmlFor="grid-state"
                >
                  Correo Electrónico
                </label>
                <Input
                  className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                  id="grid-city"
                  type="text"
                  placeholder={datos.data.contratante.correoElectronico}
                  disabled
                />
              </div>

              <div className="w-full md:w-1/4 px-3 mb-6 md:mb-0">
                <label
                  className="block  tracking-wide text-grey-darker text-xs font-light mb-1"
                  htmlFor="grid-zip"
                >
                  Número Celular
                </label>
                <MaskInput
                  id="grid-zip"
                  value={datos.data.contratante.numeroCelular}
                  mask="000-000-0000"
                  size={10}
                  disabled
                  className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Form;
